import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { ENABLE_GROUP_TABLE_KEY_LIST } from "@FillInTableContainer/shared/constants/tableCreatorGroupTable.constants";
import {
  FocusStatus,
  useTableCreatorFocusStatus,
} from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import {
  PositionInfo,
  useTableCreatorPositionInfo,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import { TableCreatorGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { getPressIdFromURL } from "@utils/getStateFromURL";

interface Props {
  groupTableKey: DealLaScSection;
  tableKey: string | null;
  groupShellList: TableCreatorGroupShellList;
  groupTableIndex: number;
  tableIndex: number;
}

interface UseHandleTableCreatorTableReturn {
  info: PositionInfo;
  focusStatus: FocusStatus;
  isFocused: boolean;
}

export const useHandleDealLaScSingleTableCreatorTable = (
  tablePropsInfo: Props,
): UseHandleTableCreatorTableReturn => {
  const { groupTableKey, tableKey, tableIndex } = tablePropsInfo;

  const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;

  const { info } = useTableCreatorPositionInfo();
  const { focusStatus } = useTableCreatorFocusStatus();

  const { data: articleInfo } = useArticleInfoQuery(
    Number(getPressIdFromURL()),
  );

  const isEnableEdit = articleInfo
    ? ENABLE_GROUP_TABLE_KEY_LIST[articleSection][groupTableKey].includes(
        articleInfo.draftArticleStatus,
      )
    : false;

  const isFocused =
    info.groupTableKey === groupTableKey &&
    info.tableKey === tableKey &&
    info.tableIndex === tableIndex &&
    isEnableEdit;

  return {
    info,
    focusStatus,
    isFocused,
  };
};
